<template>
    <div class="w-full h-[90%]">
        <form @submit.prevent="submitForm" action="" class="flex flex-col h-full w-full justify-between">
            <div class="grid grid-cols-2 gap-2">
                <div class="flex items-center">
                    <label class="whitespace-nowrap tracking-wide font-semibold pr-1 text-gray-800">
                        First Name:
                    </label>
                    <input type="text" class="p-1 border h-full w-full" v-model="personData.first_name">
                </div>
                <div class="flex items-center">
                    <label class="whitespace-nowrap tracking-wide font-semibold pr-1 text-gray-800">
                        Last Name:
                    </label>
                    <input type="text" class="p-1 border h-full w-full" v-model="personData.last_name">
                </div>
                <!-- <div class="flex items-center">
                    <label class="whitespace-nowrap tracking-wide font-semibold pr-1 text-gray-800">
                        Personal Email:
                    </label>
                    <input type="email" class="p-1 border h-full w-full" v-model="personData.personal_email">
                </div> -->
                <div class="flex flex-col border w-full">
                  <div class="w-full bg-gray-200 p-2 flex items-center justify-center">
                    Email Addresses
                  </div>
                  <div class="flex flex-col p-2 h-44 overflow-auto">
                    <div v-if="whitelistedEmail" class="m-1 p-1 border flex">
                        <input type="text" disabled class="p-1 border h-full w-full mr-1" v-model="whitelistedEmail.email_address" placeholder="email@123.com">
                        <input type="text" class="p-1 border h-full w-full mx-1" v-model="whitelistedEmail.description" placeholder="description">
                        <div class="flex items-center">
                            <base-icon-popover-hover
                                class="bg-amber-300 border-none "
                                popoverTitle="Whitelisted"
                                popoverBody="This email is whitelisted and the email address cannot be edited or removed. The description can still be edited."
                            >
                            <div class="h-6 w-6 flex items-center justify-center">
                                ✓
                            </div>
                            </base-icon-popover-hover>
                        </div>
                        <!-- <base-button-disabled >
                          <XMarkSVG stroke-color="gray"  />
                        </base-button-disabled> -->
                    </div>
                    <div v-for="email in personData.email_addresses" :key="email.id"  class="m-1 p-1 border flex">
                        <input type="text" :disabled="email.is_whitelisted" class="p-1 border h-full w-full mr-1" v-model="email.email_address" placeholder="email@123.com">
                        <input type="text" class="p-1 border h-full w-full mx-1" v-model="email.description" placeholder="description">
                        <base-button-negative @click.prevent="removeEmail(email.id)">
                          <XMarkSVG strokeColor="white" />
                        </base-button-negative>
                    </div>
                    <div class="p-1 pr-2 flex w-full justify-end">
                        <base-button-affirmative title="Add email" @click.prevent="addEmail">
                            <PlusSVG strokeColor="white" />
                        </base-button-affirmative>
                    </div>
                  </div>
                </div>
            </div>
            <!-- <div class="flex justify-center col-span-3"> -->
            <!-- </div> -->
            <div class="w-full flex items-center justify-center">
                <div class="mx-1">
                    <base-button-affirmative>
                        Save
                    </base-button-affirmative>
                </div>
                <div class="mx-1">
                    <base-button-negative @click.prevent="close">
                        Cancel
                    </base-button-negative>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup>
import { defineProps, reactive, computed, defineEmits, ref } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import { updatePerson, createPerson } from '@/services/People';
import XMarkSVG from '../svg-components/XMarkSVG.vue';
import PlusSVG from '../svg-components/PlusSVG.vue';

const store = useStore()
const $toast = useToast()

const props = defineProps(['person'])
const emit = defineEmits(['close', 'refetch-people'])

const personData = reactive({
    first_name: props.person ? props.person.first_name : null,
    last_name: props.person ? props.person.last_name : null,
    personal_email: props.person ? props.person.personal_email : null,
    email_addresses: props.person ? props.person.email_addresses.filter((email) => !email.is_whitelisted) : []
})


function close(){
    emit('close')
}

function addEmail(){
    personData.email_addresses.push({
        id: Math.random(),
        email_address: null,
        description: null
    })
}

const whitelistedEmail = ref(null)

function removeEmail(emailId){
  personData.email_addresses.splice(personData.email_addresses.findIndex((email) => email.id == emailId), 1)
}

async function submitForm(){
    const token = store.state.auth.token
    let data = {
        first_name: personData.first_name,
        last_name: personData.last_name,
        email_addresses: personData.email_addresses,
        whitelisted_email: whitelistedEmail.value
    }
    if(props.person){
        editPerson(token, props.person.id, data)
    } else {
        addPerson(token, data)
    }
}

async function editPerson(token, personId, data){
    const result = await updatePerson(token, personId, data)
    console.log('result', result)
    if(result.status == 200){
        $toast.open({
            message: `Successfully updated ${personData.first_name} ${personData.last_name}`,
            type: 'success',
            duration: 3000
        })
        emit('refetch-people')
        emit('close')
    } else {
        $toast.open({
            message: result.response.data.detail,
            // message: `Error, could not update ${personData.first_name} ${personData.last_name}`,
            type: 'error',
            duration: 3000
        })
    }
}

async function addPerson(token, data){
    const result = await createPerson(token, data)
    console.log('result', result)
    if(result.status == 201) {
        $toast.open({
            message: `Successfully Created ${personData.first_name} ${personData.last_name}.`,
            type: 'success',
            duration: 5000
        })
        emit('refetch-people')
        emit('close')
    } else {
        $toast.open({
            message: result.response.data,
            type: 'error',
            duration: 20000
        })
    }
}

function setWhitelistedEmail(){
    if(props.person){
        let email = props.person.email_addresses.find((email) => email.is_whitelisted)
        if(email){
            whitelistedEmail.value = email
        }
    }
}

setWhitelistedEmail()
</script>